<template>
	<v-card>
		<v-card-title>
			<h2>Historia poprawek</h2>
		</v-card-title>
		<v-card-text>
			<CompareOfferVersionsDialog v-if="history.length > 0" :status="offer.status"
				:contest-id="offer.contestId" :last-version="history.length + 1"/>
			<b>Nazwa oferty:</b> {{offer.title}}<br/>
			<b>Numer oferty:</b> {{offer.offerCode}}<br/>
			<b>Oferent: </b> {{offer.bidderName}}<br/>
			<b>Autor:</b> {{offer.author}}
		</v-card-text>

		<v-data-table
			hide-actions
			:headers="tableHeaders"
			:items="history"
			no-data-text="Historia zmian nie obejmuje tworzenia oferty">
			<template slot="items" slot-scope="props">
				<tr style="height: 64px">
					<td>{{ props.item.correctionDate }}</td>
					<td>{{ props.item.correctionCause }}</td>
					<td>{{ props.item.detailedCorrectionCause }}</td>
					<td>
						<v-btn @click="viewVersion(props.item.version)">
							Podgląd
						</v-btn>
					</td>
				</tr>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>
	import {Offer} from "@/api/generated/Offer";
	import CompareOfferVersionsDialog from "./compareComponents/CompareOfferVersionsDialog";

	export default {
		name: "OfferChangesHistory",
		components: {CompareOfferVersionsDialog},
		data() {
			return {
				lastVersion: null,
				offer: {
					offerCode: "",
          status: "",
					title: "",
					bidderName: "",
					author: "",
					contestId: "",
				},
				tableHeaders: [
					{text: "Data", sortable: false, width: "180px"},
					{text: "Powód", sortable: false, width: "260px"},
					{text: "Opis", sortable: false},
					{text: "Podgląd stanu przed poprawką", sortable: false},
				],
				history: [],
			};
		},

		methods: {
			refresh() {
				this.loadData();
			},

			viewVersion(version) {
				this.$router.openInNewTab("/view/contest/".concat(this.offer.contestId).concat("/offer/").concat(this.$route.params.offerId).concat("/").concat(version));
			},

			loadData() {
				Offer.getBasicData(this, this.$route.params.offerId, success => {
					this.offer.offerCode = success.offerCode;
          this.offer.status = success.offerStatus;
					this.offer.title = success.title;
					this.offer.bidderName = success.bidderName;
					this.offer.author = success.author;
					this.offer.contestId = success.contestId;
				});
				Offer.getCorrectionHistory(this, this.$route.params.offerId, success => {
					success.shift();
					this.history = success;
					if (this.history.length > 0) {
						this.lastVersion = this.history[this.history -1];
					}
				});
			},
		},

		created() {
			this.loadData();
		},
	};
</script>

<style scoped>

</style>